import { render } from "./TemplateMfittBookingResult.vue?vue&type=template&id=6cb73140&scoped=true"
import script from "./TemplateMfittBookingResult.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBookingResult.vue?vue&type=script&lang=js"

import "./TemplateMfittBookingResult.vue?vue&type=style&index=0&id=6cb73140&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6cb73140"

export default script